import * as React from 'react';
import { Button } from 'antd';

import { i18n } from 'app/i18n';
import { Image } from 'app/components/common/image';
import seeNoEvilMonkeyEmojiImage from 'app/resources/see-no-evil-monkey-emoji.svg';
import { navigationService } from 'app/service/navigation-service';
import { Typography } from 'app/components/domain/typography';
import { SmallContainer } from 'app/components/common/container';

import { FatalErrorType } from './fatal-error-type';

import style from './fatal-error.module.scss';

interface Props {
    error: FatalErrorType;
}

export const FatalError: React.FC<Props> = ({ error }) => {
    const handleGoToMyPages = () => navigationService.goToMyPages();

    return (
        <SmallContainer additionalStyles={style.content}>
            <Typography variant="heading">{i18n.fatalError.page.title[error]}</Typography>
            <Image className={style.image} src={seeNoEvilMonkeyEmojiImage} alt={i18n.image.seeNoEvilMonkeyEmoji} />
            {i18n.fatalError.page.message[error].split('\n').map((paragraph, index) => (
                <Typography key={index} variant="subtitle3" component="p" className={style.description}>
                    {paragraph}
                </Typography>
            ))}
            <div className={style.buttonsContainer}>
                <Button type="primary" onClick={handleGoToMyPages}>
                    {i18n.fatalError.page.button.goToAltibox}
                </Button>
            </div>
        </SmallContainer>
    );
};
